import {
  initialState,
  Actions,
  State,
  GET_COMMUNITY_SUBSCRIBERS,
  GET_COMMUNITY_SUBSCRIBERS_SUCCESS,
  GET_COMMUNITY_SUBSCRIBERS_ERROR,
} from "../../types/community/subscribers";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_COMMUNITY_SUBSCRIBERS:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_COMMUNITY_SUBSCRIBERS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_COMMUNITY_SUBSCRIBERS_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: true,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
